/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React, { PropTypes } from 'react';
import getTradeNote from 'controllers/school/getTradeNote'
import getStudentInfo from 'controllers/student/getStudentInfo'
import getClientDetail from 'controllers/client/getClientDetail'
import moment from 'moment'
import './Modal.scss';

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      finance: {
        notes: '',
      },
      studentInfo: {
        ssRemark: '',
        ssFirstName: '',
        ssLastName: '',
        ssPhone: '',
        ssBirthday: '',
        ssGender: '',
        ssStudentCreateTime: '',
        ssEmail: ''
      },
      clientInfo: {
        first_name: '',
        last_name: '',
        gender: 'male',
        date_of_birth: '',
        mobile: '',
        email: '',
        guardian_name: '',
        guardian_mobile: '',
        guardian_email: '',
        tag_name_list: [],
        remark: '',
      }
    }

    this.onChange = this.onChange.bind(this)
  }

  componentDidMount() {
    const {id, type} = this.props
    if(type == 'finance'){
      getTradeNote(id)
      .then((res) => {
        this.state.finance.notes = res.notes

        this.setState({finance: this.state.finance})
      })
    } else if (type == 'student'){
      getStudentInfo(id)
      .then((res) => {
        this.state.studentInfo.ssFirstName = res.ssFirstName
        this.state.studentInfo.ssLastName = res.ssLastName
        this.state.studentInfo.ssPhone = res.ssPhone
        this.state.studentInfo.ssBirthday = res.ssBirthday
        this.state.studentInfo.ssGender = res.ssGender == 0 ? 'male' : 'female'
        this.state.studentInfo.ssStudentCreateTime = res.ssStudentCreateTime
        this.state.studentInfo.ssRemark = res.ssRemark
        this.state.studentInfo.ssEmail = res.ssEmail

        this.setState({
          studentInfo: this.state.studentInfo
        })
      })
    } else if (type == 'client'){
      getClientDetail(id)
      .then((res) => {
        let convertedGender = '';
        if (res.gender == 0){
          convertedGender = 'male'
        } else if (res.gender == 1){
          convertedGender = 'female'
        }

        this.setState({
          clientInfo: {
            ...this.state.clientInfo,
            first_name: res.first_name,
            last_name: res.last_name,
            gender: convertedGender,
            date_of_birth: res.birthday ? moment(res.birthday).format('YYYY-MM-DD') : '',
            mobile: res.mobile,
            email: res.email,
            guardian_name: res.guardian_name,
            guardian_mobile: res.guardian_mobile,
            guardian_email: res.guardian_email,
            tag_name_list: res.tag_name_list,
            remark: res.remark,
          }
        })
      })
    }
  }

  onChange(event) {
    let {
      onFormChange,
      type
    } = this.props;

    if(type == 'finance'){
      this.state.finance.notes = event.target.value
      this.setState({finance: this.state.finance}, ()=> {onFormChange(this.state.finance)})
    } else if (type == 'student'){
      this.state.studentInfo.ssRemark = event.target.value
      this.setState({ssRemark: this.state.studentInfo}, ()=> {onFormChange(this.state.studentInfo)})
    } else if (type == 'client'){
      this.state.clientInfo.remark = event.target.value
      this.setState({remark: this.state.clientInfo}, () => {onFormChange(this.state.clientInfo)})
    }

  }

  renderValue(){
    const {type} = this.props
    if(type == 'finance'){
      return this.state.finance.notes
    } else if (type == 'student'){
      return this.state.studentInfo.ssRemark
    } else if (type == 'client'){
      return this.state.clientInfo.remark
    }
  }

  render() {
    const {type} = this.props

    return (
      <div className='remarks-modal-content'>
        <div className='container-fluid'>
          <textarea
            rows='12' cols='59'
            className='form-control'
            onChange={this.onChange}
            value={this.renderValue()}
            placeholder={__('Please enter remarks content', 'finance')}
          />
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/Remarks/ModalContent.js